import { Check, X } from "lucide-react";
import { useEffect, useRef, useState } from "react";

import {
  CLIPBOARD_FEEDBACK_EVENT,
  type ClipboardFeedbackDetail,
} from "./lib/clipboard";

interface VisibleFeedback extends ClipboardFeedbackDetail {
  id: number;
}

export function ClipboardFeedback() {
  const [feedback, setFeedback] = useState<VisibleFeedback | null>(null);
  const timeout = useRef<number | undefined>(undefined);

  useEffect(() => {
    const showFeedback = (event: Event) => {
      const detail = (event as CustomEvent<ClipboardFeedbackDetail>).detail;
      window.clearTimeout(timeout.current);
      setFeedback({ ...detail, id: Date.now() });
      timeout.current = window.setTimeout(() => setFeedback(null), 1800);
    };
    window.addEventListener(CLIPBOARD_FEEDBACK_EVENT, showFeedback);
    return () => {
      window.removeEventListener(CLIPBOARD_FEEDBACK_EVENT, showFeedback);
      window.clearTimeout(timeout.current);
    };
  }, []);

  if (!feedback) return null;
  return (
    <div
      className={`clipboard-feedback ${feedback.tone}`}
      key={feedback.id}
      role={feedback.tone === "error" ? "alert" : "status"}
      aria-live="polite"
    >
      {feedback.tone === "success" ? <Check aria-hidden="true" /> : <X aria-hidden="true" />}
      <strong>{feedback.message}</strong>
    </div>
  );
}
